// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import BaseModel from '@glittr/frontend-core/src/plugins/servicelayer/serviceTypes/baseModel';
import ResourceLinkViewModel from '../../../../viewModel/resource/ResourceLinkViewModel';
import PriceResourceViewModel from '../../../../viewModel/resource/PriceResourceViewModel';
import ArticleVariantResourceViewModel from '../../../../viewModel/resource/ArticleVariantResourceViewModel';
import ArticleResourceViewModel from '../../../../viewModel/resource/ArticleResourceViewModel';
import ArticleResourceDTO from '../../dto/resource/ArticleResourceDTO';

export default abstract class ArticleResourceModel extends BaseModel<ArticleResourceDTO> {
  /**
  * @type {int64}
  */
  get id() { return this.dto.id; }
  set id(value) { this.dto.id = value; }
  /**
  */
  get links() { return this.getArrayModels(() => this.dto.links, ResourceLinkViewModel)!; }
  set links(value) { this.setArrayModels(() => this.dto.links, value); }
  /**
  */
  get title() { return this.dto.title; }
  set title(value) { this.dto.title = value; }
  /**
  */
  get description() { return this.dto.description; }
  set description(value) { this.dto.description = value; }
  /**
  */
  get detailDescription() { return this.dto.detailDescription; }
  set detailDescription(value) { this.dto.detailDescription = value; }
  /**
  * @type {int32}
  */
  get articleNumber() { return this.dto.articleNumber; }
  set articleNumber(value) { this.dto.articleNumber = value; }
  /**
  */
  get abbreviation() { return this.dto.abbreviation; }
  set abbreviation(value) { this.dto.abbreviation = value; }
  /**
  */
  get dimensions() { return this.dto.dimensions; }
  set dimensions(value) { this.dto.dimensions = value; }
  /**
  * @type {double}
  */
  get weight() { return this.dto.weight; }
  set weight(value) { this.dto.weight = value; }
  /**
  */
  get prices() { return this.getArrayModels(() => this.dto.prices, PriceResourceViewModel)!; }
  set prices(value) { this.setArrayModels(() => this.dto.prices, value); }
  /**
  */
  get imageDetailId() { return this.dto.imageDetailId; }
  set imageDetailId(value) { this.dto.imageDetailId = value; }
  /**
  */
  get imagePreviewId() { return this.dto.imagePreviewId; }
  set imagePreviewId(value) { this.dto.imagePreviewId = value; }
  /**
  */
  get variants() { return this.getArrayModels(() => this.dto.variants, ArticleVariantResourceViewModel)!; }
  set variants(value) { this.setArrayModels(() => this.dto.variants, value); }

  protected transformFromQuery(queries: Record<string, string>): void {
    const qs = {} as Record<string, string>;
    Object.keys(queries).forEach((key) => { qs[key.toLowerCase()] = queries[key]; });
    let value: any;
    value = Number.parseFloat(qs.id);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.id = value;
    this.dto.title = qs.title;
    this.dto.description = qs.description;
    this.dto.detailDescription = qs.detaildescription;
    value = Number.parseFloat(qs.articlenumber);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.articleNumber = value;
    this.dto.abbreviation = qs.abbreviation;
    this.dto.dimensions = qs.dimensions;
    value = Number.parseFloat(qs.weight);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.weight = value;
    this.dto.imageDetailId = qs.imagedetailid;
    this.dto.imagePreviewId = qs.imagepreviewid;
  }
}
